import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { ClientDetails } from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { isTaxRelifAvailable } from "../../../NewQuoteWizard/Components/Shared/Utils";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { PaymentType, processTypeEnum } from "../../Resource/Contents";
import { PaymentMethods } from "./PaymentMethods";
import { ThirdPartyEmployerDetail } from "./ThirdPartyEmployerDetail";

interface ISinglePaymentDetailProps extends IProcessComponentProps {
    clientInfo: ClientDetails;
    type: PaymentType;
    subAccountType: SubAccountType;
    hasPaymentMethod: boolean;
    bankAccounts?: BankAccount[];
    bankAccountInstructions?: BankAccountInstruction[];
    excludeWrapCash?: boolean;
    processType: processTypeEnum;
    onSaveNewBankAccountInstruction?: (BankAccountInstruction: BankAccountInstruction) => void;
    onRemoveBankAccountInstruction?: (BankAccountInstruction: BankAccountInstruction) => void;
    inUseBankAccountInstruction?: string[];
}

interface ISinglePaymentDetailState {}

export class SinglePaymentDetail extends ProcessComponent<ISinglePaymentDetailProps, ISinglePaymentDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const bankAcocunts = this.props.bankAccounts;
        const bankAccountInstuctions = this.props.bankAccountInstructions;
        const {
            type,
            data,
            hasPaymentMethod,
            onChange,
            excludeWrapCash,
            processType,
            onSaveNewBankAccountInstruction,
            onRemoveBankAccountInstruction,
            inUseBankAccountInstruction,
            clientInfo,
        } = this.props;
        return (
            <>
                <h4>{type}</h4>
                <div className="row pb-20">
                    <div className="col-md-4 col-12">
                        <MoneyTextBoxEditor
                            required={"Please enter single payment"}
                            value={data?.Money?.Amount || 0}
                            currency={data?.Money?.Currency || CurrencyCode.GBP}
                            label={
                                data?.TaxRelief && SubAccountTypeHelper.isOnPlatformPension(this.props.subAccountType)
                                    ? "Single payment (net)"
                                    : "Single payment"
                            }
                            onChange={(v) => onChange({ Money: { Amount: v, Currency: CurrencyCode.GBP } })}
                            validationRules={[
                                {
                                    errorMessage: "Single payment value must be > 0",
                                    validator: (v) => v > 0,
                                },
                            ]}
                        />
                    </div>

                    {hasPaymentMethod && (
                        <PaymentMethods
                            data={data}
                            isReview={this.props.isReview}
                            onChange={(v) => onChange(v)}
                            bankAccountInstructions={bankAccountInstuctions}
                            bankAccounts={bankAcocunts}
                            payeeType={type}
                            onRef={(ref) => this.appendChild(ref)}
                            excludeWrapCash={excludeWrapCash}
                            directDebitOnly={false}
                            subAccountType={this.props.subAccountType}
                            showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                            onSaveNewBankAccountInstruction={onSaveNewBankAccountInstruction}
                            onRemoveBankAccountInstruction={onRemoveBankAccountInstruction}
                            inUseBankAccountInstruction={inUseBankAccountInstruction}
                            customerId={clientInfo?.ActorId}
                        ></PaymentMethods>
                    )}
                </div>

                {type != PaymentType.Employer && SubAccountTypeHelper.isOnPlatformPension(this.props.subAccountType) && (
                    <div className="row">
                        <div className="col-12">
                            <RadiosEditor
                                cssWrapper="rg-150 mb-16"
                                label={"Include tax relief?"}
                                selected={data?.TaxRelief}
                                options={[true, false]}
                                getText={(v) => (v ? "Yes" : "No")}
                                onChange={(v) => onChange({ TaxRelief: v })}
                                disabled={!isTaxRelifAvailable(this.props.clientInfo?.DateOfBirth, new Date())}
                                required={"Please select include tax relief"}
                                infoText={
                                    data?.TaxRelief
                                        ? `<strong> ${MoneyDisplayHelper.FromatMoneyDisplay(
                                              (data?.Money?.Amount || 0) * 1.25,
                                              data?.Money?.CurrencyCode || CurrencyCode.GBP
                                          )} </strong> including tax relief (gross)`
                                        : null
                                }
                                infoTextGridClasses="pt-4"
                            />
                        </div>
                    </div>
                )}
                {type != PaymentType.Client && processType != processTypeEnum.Quote && (
                    <ThirdPartyEmployerDetail
                        paymentType={this.props.type}
                        subAccountType={this.props.subAccountType}
                        data={data}
                        onChange={(v) => onChange(v)}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                )}
            </>
        );
    }
}
